import { GET_RISK_MANAGEMENT } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const RiskManagement = (payload) => {
  return apiInstance.post(GET_RISK_MANAGEMENT, payload);
};
